// src/pages/NoPermisos.jsx
import React from "react";

export default function NoPermisos() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Sin permisos</h2>
      <p>No tienes acceso a esta sección.</p>
    </div>
  );
}
